import { VImg } from 'vuetify/lib/components/VImg';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "hero-section" }, [
    _c(
      "div",
      { staticClass: "hero-section__cover-wrapper rounded-t-20" },
      [
        _c(VImg, {
          staticClass: "rounded-t-20",
          attrs: {
            "aspect-ratio": _setup.isMobile ? 4 / 3 : 3 / 1,
            src: _setup.isMobile
              ? _vm.lpuBranding?.cover_mobile?.url
              : _vm.lpuBranding?.cover_desktop?.url,
            contain: "",
          },
          scopedSlots: _vm._u([
            {
              key: "placeholder",
              fn: function () {
                return [
                  _c("div", {
                    staticClass: "bg-lpu-branding-color-primary h-100",
                  }),
                ]
              },
              proxy: true,
            },
          ]),
        }),
        _vm._v(" "),
        _c(_setup.LpuLogo, {
          staticClass: "hero-section__logo",
          attrs: { lpu: _vm.lpu },
        }),
        _vm._v(" "),
        _vm.lpuVideoCard?.video_path?.url
          ? _c(_setup.VideoCard, {
              staticClass: "hero-section__video-card",
              attrs: {
                "video-url": _vm.lpuVideoCard.video_path.url,
                "video-uuid": _vm.lpuVideoCard.uuid,
              },
            })
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "hero-section__lpu-actions" },
          [
            _c(_setup.LpuFavouriteBtn, { attrs: { "lpu-id": _vm.lpu.id } }),
            _vm._v(" "),
            _c(_setup.LpuShareBtn, { attrs: { lpu: _vm.lpu } }),
          ],
          1
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "hero-section__info rounded-20" },
      [
        _c(_setup.LpuHeadline, { attrs: { lpu: _vm.lpu } }),
        _vm._v(" "),
        _c(_setup.TrustBadges, { attrs: { lpu: _vm.lpu } }),
        _vm._v(" "),
        _c(_setup.RatingCard, {
          attrs: { stars: _vm.lpu.stars ?? 0, allrates: _vm.lpu.allrates },
        }),
        _vm._v(" "),
        _c(_setup.LeaveRateBtn, {
          staticClass: "w-100 mt-1",
          attrs: { "lpu-id": _vm.lpu.id, "is-closed": _vm.lpu.closed },
        }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "d-flex flex-column gr-4 my-4" },
          [
            _c(_setup.TownLocation, { attrs: { town: _vm.lpu.town } }),
            _vm._v(" "),
            _c(_setup.LpuType, { attrs: { lpu: _vm.lpu } }),
            _vm._v(" "),
            !_vm.lpu.closed
              ? _c(_setup.LpuMistakeBtn, { attrs: { "lpu-id": _vm.lpu.id } })
              : _vm._e(),
          ],
          1
        ),
        _vm._v(" "),
        _c(_setup.LpuDoctors, { attrs: { lpu: _vm.lpu } }),
        _vm._v(" "),
        _c(_setup.LpuPrices, {
          attrs: {
            lpu: _vm.lpu,
            "synonym-prices-count": _vm.synonymPricesCount,
          },
        }),
        _vm._v(" "),
        _c(_setup.LpuAddress, { attrs: { lpu: _vm.lpu } }),
        _vm._v(" "),
        _c(_setup.WorkSchedule, { attrs: { lpu: _vm.lpu } }),
        _vm._v(" "),
        _c(_setup.LpuPhone, { attrs: { lpu: _vm.lpu } }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }